import { ComponentType, lazy, Suspense } from 'react';
import { ErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary';
import { ServerError } from '@cld/empty-state';

const errorHandler: ErrorBoundaryProps['onError'] = (error) => {
  console.error('LAZY-LOAD:', error);
};

const FallbackComponent = () => <ServerError />;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyComponent = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) => {
  const Component = lazy(factory);

  return function lazyComp(props: React.ComponentProps<T>) {
    return (
      <ErrorBoundary onError={errorHandler} FallbackComponent={FallbackComponent}>
        <Suspense fallback={<></>}>
          <Component {...props} />
        </Suspense>
      </ErrorBoundary>
    );
  };
};
